import { apiMngClient } from "~/plugins/http";
import { getCurrentBase } from "~/helpers/persistenceBase";
import { INewManyPayload, ICloseReminderPayload, IActualRemindersResult, IRemindersDetailed } from "~/types/reminders";
import { ICommonResult, ICommonIDResult, IApiResponse } from "~/types/common";

export const createManyReminders = (payload: INewManyPayload): Promise<IApiResponse<ICommonIDResult>> => {
  return apiMngClient.post(`/${getCurrentBase()}/Reminders/NewMany`,
    payload,
  );
};

export const updateReminder = (payload: IRemindersDetailed): Promise<IApiResponse<ICommonIDResult>> => {
  return apiMngClient.post(`/${getCurrentBase()}/Reminders/Update`,
    payload,
  );
};

export const closeReminder = (payload: ICloseReminderPayload): Promise<IApiResponse<ICommonResult>> => {
  return apiMngClient.post(`/${getCurrentBase()}/Reminders/Close`, payload);
};

export const getActualReminders = (): Promise<IApiResponse<IActualRemindersResult>> => {
  return apiMngClient.post(`/${getCurrentBase()}/Reminders/List`,
    {
      count: 150,
      filters: [{ column: 'isActual', value: true, operation: 'Equal' }],
      orderDesc: true,
      skip: 0,
    },
  );
};

export const getAllReminders = (): Promise<IApiResponse<IActualRemindersResult>> => {
  return apiMngClient.post(`/${getCurrentBase()}/Reminders/List`,
    {
      count: 150,
      filters: [],
      orderDesc: true,
      skip: 0,
    },
  );
};

export const getDetailedReminder = (id: number): Promise<IApiResponse<IRemindersDetailed>> => {
  return apiMngClient.get(`/${getCurrentBase()}/Reminders/item?id=${id}`);
};